module.exports = __webpack_public_path__ + "e605bfc5af2cd629d5cd9539dc224026.svg";